import { useTranslation } from 'react-i18next'

import { CellCentered } from './CellCentered'
import { NotFoundCellProps } from './types'

export const NotFoundCell = ({ columnsCount }: NotFoundCellProps): React.JSX.Element => {
  const { t } = useTranslation('common')

  return <CellCentered columnsCount={columnsCount}>{t('filter.nothingFound')}</CellCentered>
}
